
import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,

  Button,
  Pagination,
  Box,
  TextField,
  InputAdornment,
  ModalPreviewComponent,
  FormControl,
  Divider,
  Grid,
  Avatar,
} from "@mui/material";
import { RiEyeLine } from "react-icons/ri";
import { AiOutlineDelete, AiOutlineSearch } from "react-icons/ai";
import { RiPencilLine } from "react-icons/ri";

import { toast, ToastContainer } from "react-toastify";
import { Formik, Form } from "formik";
import CustoDropDownRegister from "../CustomDropDown/CustoDropDownRegister";
import { LuCircleCheckBig, LuCircleChevronUp } from "react-icons/lu";
import { batchOptions, courseOptions } from "../../Pages/DataEntries/DataEntries";
import CustomInputLogin from "../CustomInputLogin/CustomInputLogin";
import { useNavigate } from "react-router-dom";
import { RxCrossCircled } from "react-icons/rx";
// import ALUMNIREGISTRATIONCONFIRMCommendModal from "../ALUMNIREGISTRATIONCONFIRMCommandModal/ALUMNIREGISTRATIONCONFIRMCommendModal";



const CustomTable = ({
  // handleDeleteById,
  showViewMore,
  handleEditById,
  componentModalName: ModalViewComponent,
  handleViewModal,
  handleDeletePost,
  tableSearch,
  handleAddNavigate,
  handleConFrimButton,
  registrationConfirmed,
  searchByName,
  tableReportSearch,
  tableActions,
  handleALUMNIREGISTRATIONCONFIRMModalOpen,
  tableView,
  tableDelete,
  handleRejectModalOpen,
  tableEdit,
  tableData,
  tableHeadData,
  searchByCourse,
  title,
  handleTableDataDelete,
}) => {
  // const rowsPerPage = rowPerPage ? rowPerPage : 5; // Display only 3 rows per page
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [currentPage, setCurrentPage] = useState(0);

  console.log(tableData, "tableDatatableDatatableData")

  // const [isALUMNIREGISTRATIONCONFIRMCommandModalOpen, setALUMNIREGISTRATIONCONFIRMCommandModalOpen] = useState(false)

  // const handleALUMNIREGISTRATIONCONFIRMModalOpen = () => {
  //   setALUMNIREGISTRATIONCONFIRMCommandModalOpen(true)
  // }

  // const handleALUMNIREGISTRATIONCONFIRMModalClose = () => {
  //   setALUMNIREGISTRATIONCONFIRMCommandModalOpen(false)
  // }


  // -----------------------modal for operator user registraion is end---------------------

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage - 1); // Adjust for 0-based `currentPage`
  };


  const pageCount = Math.ceil(tableData?.length / rowsPerPage);

  // Paginated data

  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState(tableData);
  console.log(data, "datattatata");

  useEffect(() => {
    if (tableData) {
      setData(tableData);
    }
  }, [tableData]);
  console.log(data, "datattatata1111");

  const [filters, setFilters] = useState({
    filterByCampusName: "",
    filterByConfirmedStatus: "",
    CampusName: "",
    courseName: "",
    batchyear: "",
    studentName: ""
  });
  console.log(filters, "filters")

  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
  };
  const [isViewModalOpen, setViewModalName] = useState(false)
  const handleViewModalOpen = () => {
    setViewModalName(true)
  }
  const handleViewModalClose = () => {
    setViewModalName(false)
  }


  // const filteredData = tableData.filter((row) => {
  //   const matchesSearch = Object.values(row).some((value) =>
  //     String(value || "").toLowerCase().includes(searchTerm.toLowerCase())
  //   );

  //   const matchesCampus =
  //     filters.filterByCampusName === "" ||
  //     filters.filterByCampusName === "AllCampus" ||
  //     row.campus === filters.filterByCampusName;

  //   const matchesConfirmedStatus =
  //     filters.filterByConfirmedStatus === "" ||
  //     filters.filterByConfirmedStatus === "All" ||
  //     row.status === filters.filterByConfirmedStatus;

  //   return matchesSearch && matchesCampus && matchesConfirmedStatus;
  // });


  // const filteredData = tableData.filter((row) => {
  //   const matchesSearch = Object.values(row).some((value) =>
  //     String(value || "").toLowerCase().includes(searchTerm.toLowerCase())
  //   );

  //   const matchesCampus =
  //     filters.filterByCampusName === "" || filters.filterByCampusName === "AllCampus" ||
  //     row.campus === filters.filterByCampusName;

  //   const matchesConfirmedStatus =
  //     filters.filterByConfirmedStatus === "" || filters.filterByConfirmedStatus === "All" ||
  //     row.status.toLowerCase() === filters.filterByConfirmedStatus.toLowerCase();

  //   return matchesSearch && matchesCampus && matchesConfirmedStatus;
  // });

  console.log(tableData, "tableData")
  // const filteredData = tableData.filter((row) => {
  //   const matchesSearch = Object.values(row).some((value) =>
  //     String(value || "").toLowerCase().includes(searchTerm.toLowerCase())
  //   );
  //   console.log(row, "row")

  //   console.log(matchesSearch, "matchesSearch11")

  //   const matchesCampus =
  //     !registrationConfirmed ||
  //     filters.filterByCampusName === "" ||
  //     filters.filterByCampusName === "All Campus" ||
  //     row.campus?.toLowerCase() === filters.filterByCampusName?.toLowerCase();
  //     console.log(filters.CampusName, "filters.CampusNamefilters.CampusName")

  //   console.log(matchesCampus, "matchesSearch22")

  //   const matchesCampusForSearchByName =
  //     !registrationConfirmed ||
  //     filters.CampusName === "" ||
  //     filters.CampusName === "All Campus" ||
  //     String(row.status)?.toLowerCase() === filters.CampusName?.toLowerCase();

  //   const matchesConfirmedStatus =
  //     !registrationConfirmed ||
  //     filters.filterByConfirmedStatus === "" ||
  //     filters.filterByConfirmedStatus === "All" ||
  //     String(row.status)?.toLowerCase() === filters.filterByConfirmedStatus?.toLowerCase();

  //   console.log(matchesConfirmedStatus, "matchesSearch33")

  //   const matchesCourse =
  //     !searchByCourse ||
  //     filters.courseName === "" ||
  //     filters.courseName === "All Course" ||
  //     row.course.toLowerCase() === filters.courseName.toLowerCase();
  //   console.log(row.course, "matchesSearch44")

  //   console.log(matchesCourse, "matchesSearch44")


  //   const matchesBatch =
  //     !searchByCourse ||
  //     filters.batchyear === "" ||
  //     filters.batchyear === "All Batch" ||
  //     row.batch === filters.batchyear;
  //   console.log(matchesBatch, "matchesSearch55")

  //   const matchesName =
  //     // !searchByCourse ||
  //     filters.studentName === "" ||
  //     // filters.batchyear === "All Batch" ||
  //     row.firstName.toLowerCase() === filters?.studentName?.toLowerCase();
  //   console.log(matchesName, "matchesSearch66")

  //   console.log(matchesName, "matchesSearch66")

  //   return matchesSearch && matchesName && matchesCampusForSearchByName && matchesCampus && matchesConfirmedStatus && matchesCourse && matchesBatch;
  // });

  // console.log(filteredData, "filteredData")


  // const filteredData = tableData.filter((row) => {
  //   const matchesSearch = Object.values(row).some((value) =>
  //     String(value || "").toLowerCase().includes(searchTerm.toLowerCase())
  //   );
  //   console.log(row, "row");
  //   console.log(matchesSearch, "matchesSearch11");

  //   const matchesCampus =
  //     !registrationConfirmed ||
  //     filters.filterByCampusName === "" ||
  //     filters.filterByCampusName === "All Campus" ||
  //     row.campus?.toLowerCase() === filters.filterByCampusName?.toLowerCase();
  //   console.log(filters.filterByCampusName, "filters.filterByCampusName");
  //   console.log(matchesCampus, "matchesCampus");

  //   const matchesConfirmedStatus =
  //     !registrationConfirmed ||
  //     filters.filterByConfirmedStatus === "" ||
  //     filters.filterByConfirmedStatus === "All" ||
  //     String(row.status)?.toLowerCase() === filters.filterByConfirmedStatus?.toLowerCase();
  //   console.log(matchesConfirmedStatus, "matchesConfirmedStatus");

  //   const matchesCourse =
  //     !searchByCourse ||
  //     filters.courseName === "" ||
  //     filters.courseName === "All Course" ||
  //     row.course.toLowerCase() === filters.courseName.toLowerCase();
  //   console.log(row.course, "row.course");
  //   console.log(matchesCourse, "matchesCourse");

  //   const matchesBatch =
  //     !searchByCourse ||
  //     filters.batchyear === "" ||
  //     filters.batchyear === "All Batch" ||
  //     row.batch === filters.batchyear;
  //   console.log(matchesBatch, "matchesBatch");

  //   const matchesName =
  //     filters.studentName === "" ||
  //     row.firstName.toLowerCase() === filters?.studentName?.toLowerCase();
  //   console.log(matchesName, "matchesName");

  //   return (
  //     matchesSearch &&
  //     matchesName &&
  //     matchesCampus &&
  //     matchesConfirmedStatus &&
  //     matchesCourse &&
  //     matchesBatch
  //   );
  // });

  const filteredData = tableData?.filter((row) => {
    // Check if the row matches the search term
    const matchesSearch = Object.values(row).some((value) =>
      String(value || "").toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Check if the row matches campus filter
    const matchesCampus =
      !registrationConfirmed ||
      !filters?.filterByCampusName ||
      filters?.filterByCampusName === "All Campus" ||
      row.campus?.toLowerCase() === filters?.filterByCampusName.toLowerCase();

    // Check if the row matches confirmed status filter
    const matchesConfirmedStatus =
      !registrationConfirmed ||
      !filters?.filterByConfirmedStatus ||
      filters?.filterByConfirmedStatus === "All" ||
      String(row.status)?.toLowerCase() === filters?.filterByConfirmedStatus.toLowerCase();

    // Check if the row matches course filter
    const matchesCourse =
      !searchByCourse ||
      !filters?.courseName ||
      filters?.courseName === "All Course" ||
      row.course?.toLowerCase() === filters?.courseName.toLowerCase();

    // Check if the row matches batch filter
    const matchesBatch =
      !searchByCourse ||
      !filters?.batchyear ||
      filters?.batchyear === "All Batch" ||
      row.yearOfCompletion === filters?.batchyear;
    console.log(row?.yearOfCompletion, "year")
    console.log(filters?.batchyear, "year")


    // Check if the row matches student name filter
    const matchesName =
      !filters?.studentName ||
      row.firstName?.toLowerCase() === filters?.studentName.toLowerCase();

    // Return true if all filter conditions are met
    return (
      matchesSearch &&
      matchesCampus &&
      matchesConfirmedStatus &&
      matchesCourse &&
      matchesBatch &&
      matchesName
    );
  });

  // Paginate the filtered data

  console.log(filteredData, "filteredData");

  // if (registrationConfirmed) {
  //   setFilters({
  //     filterByCampusName: values.filterByCampusName,
  //     filterByConfirmedStatus: values.filterByConfirmedStatus,
  //   });
  // } else if (searchByCourse) {
  //   setFilters({
  //     CampusName: values.CampusName,
  //     courseName: values.courseName,
  //     batchyear: values.batchyear,
  //   });
  // }




  const paginatedData = filteredData?.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );
  console.log(paginatedData, "paginatedDatapaginatedData");

  // Handle delete functionality
  const handleDeleteRow = async (index, id) => {

    if (!id) {
      const updatedData = [...data];
      updatedData.splice(index + currentPage * rowsPerPage, 1);
      setData(updatedData);
    } else {
      handleTableDataDelete(id)


    }
  };

  const handleChange = (event) => {
    setRowsPerPage(event.target.value);
  };

  const customInitialValues = registrationConfirmed
    ? {
      filterByCampusName: "",
      filterByConfirmedStatus: "",
    }
    : (searchByCourse) ? {
      CampusName: "",
      courseName: "",
      batchyear: ""
    } : {
      studentName: ""
    }
  const navigate = useNavigate()
  const handleProfileNavigate = (id) => {
    console.log(id, "userIddddddd")
    navigate(`/admin/profiledetails/${id}`)
  }

  return (
    <>
      <Typography variant="h6" gutterBottom>{title}</Typography>
      <Divider />
      <Grid

        container
      // xs={12}
      // sx={{ background: "white", borderRadius: "5px", mt: 1, px: 2, pb: 2 }}
      >

        <Grid sx={{ width: "100%" }}>
          {tableReportSearch && (
            <>
              <Grid
                // display="flex"
                // justifyContent="space-between"
                // alignItems="center"
                mt={1}
              >

                <Box>
                  <Formik
                    initialValues={customInitialValues}
                    // validationSchema={validationSchema}
                    onSubmit={(values) => {
                      if (registrationConfirmed) {

                        setFilters({
                          filterByCampusName: values.filterByCampusName,
                          filterByConfirmedStatus: values.filterByConfirmedStatus,
                        });
                      } else if (searchByCourse) {
                        setFilters({
                          CampusName: values.CampusName,
                          courseName: values.courseName,
                          batchyear: values.batchyear,
                        });
                        // studentName
                      }
                      else if (searchByName) {
                        setFilters({
                          studentName: values.studentName,
                        });

                      }
                      console.log(values, "valuessssss")
                    }}
                  >
                    {({ isSubmitting, values, setFieldValue, resetForm, errors, touched, handleChange, handleBlur }) => (
                      <Form>
                        <Grid container spacing={2}>
                          {registrationConfirmed && (
                            <>
                              <Grid item size={{ md: 3, xs: 12 }}>
                                <CustoDropDownRegister
                                  name="filterByCampusName"
                                  label="Filter by Campus Name"
                                  custPlaceholder="--Select--"
                                  // disabled
                                  options={[
                                    { label: "All Campus", value: "All Campus" },

                                  ]}
                                />
                              </Grid>
                              <Grid item size={{ md: 3, xs: 12 }}>

                                <CustoDropDownRegister
                                  name="filterByConfirmedStatus"
                                  label="Filter by Confirmed Status"
                                  custPlaceholder="--Select--"
                                  options={[
                                    { label: "All", value: "All" },
                                    { label: "Cofirmed", value: "approved" },
                                    { label: "Not Confirmed", value: "pending" },
                                  ]}
                                />
                              </Grid>
                            </>
                          )}
                          {searchByCourse && (
                            <>
                              <Grid item size={{ md: 3, xs: 12 }}>
                                <CustoDropDownRegister
                                  name="CampusName"
                                  label="Campus Name"
                                  custPlaceholder="--Select--"
                                  // disabled
                                  options={[
                                    { label: "All Campus", value: "All Campus" },

                                  ]}
                                />
                              </Grid>
                              <Grid item size={{ md: 3, xs: 12 }}>
                                <CustoDropDownRegister
                                  name="courseName"
                                  label="Course Name"
                                  custPlaceholder="--Select--"
                                  // disabled
                                  options={courseOptions.map((course, index) => ({
                                    label: course,
                                    value: course
                                  }))}
                                />
                              </Grid>
                              <Grid item size={{ md: 3, xs: 12 }}>

                                <CustoDropDownRegister
                                  name="batchyear"
                                  label="Batch Year"
                                  custPlaceholder="--Select--"
                                  options={batchOptions.map((batch, index) => ({
                                    label: batch,
                                    value: batch
                                  }))}

                                />
                              </Grid>
                            </>
                          )}
                          {searchByName && (
                            <>
                              <Grid item size={{ md: 3, xs: 12 }}>
                                <CustomInputLogin
                                  name="studentName"
                                  label="Student Name"
                                  custPlaceholder="Student Name"

                                />
                              </Grid>

                            </>
                          )}

                          <Grid item size={{ md: 3, xs: 12 }} sx={{ display: "flex", alignItems: "center" }}>

                            <Box sx={{ mt: { xs: 1, md: 2.5 }, display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <Button
                                // onClick={() => {
                                //   handleAddNavigate()
                                // }}
                                type="submit"
                                variant="contained"
                                sx={{
                                  textTransform: "none",
                                  color: "white",
                                  fontSize: "16px",
                                  padding: { xs: "0px 20px", md: "0px 20px" },

                                  boxShadow: "none",
                                  minHeight: "40px",
                                  // borderRadius: "23px",
                                  background: "var(--main-color) 0% 0% no-repeat padding-box",
                                  "&:hover": {
                                    backgroundColor: "var(--main-color)",
                                  },
                                }}
                              >
                                Search
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>

                      </Form>
                    )}
                  </Formik>
                </Box>

                {tableSearch && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mt: 1,
                      mb: 1,
                    }}
                  >
                    <TextField
                      placeholder="Search..."
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      sx={{
                        width: { xs: "100px", md: "150px" },

                        borderColor: "#C38F51",
                        // mb: 2,
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "1.5px solid #C38F51",
                          // p:"2px",
                          // height: '42px'
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "5px",
                          // borderColor: "#C38F51",
                          // border: "2px solid #C38F51",

                          backgroundColor: "white",
                          // backgroundColor: "#f9f9f9",
                          "&:hover fieldset": {
                            borderColor: "#C38F51",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#C38F51",
                          },
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <AiOutlineSearch
                              style={{ color: "#C38F51", fontSize: "20px" }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                )}
              </Grid>
              <Grid>
                <Typography variant="body1" mt={2}>
                  TOTAL RECORDS: {paginatedData?.length}
                </Typography>
              </Grid>
            </>
          )}
          <Grid

            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              // mb: 1,
              // mt: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                mb: 1,
                mt: 1,
              }}
            >
              <Typography variant="body1" sx={{ marginRight: 1, color: "#7A7A7A" }}>
                Show
              </Typography>
              <FormControl>
                {/* <label htmlFor="items-per-page">Items</label> */}
                <select
                  style={{ height: "30px", color: "#7A7A7A" }}
                  id="items-per-page"
                  value={rowsPerPage}
                  onChange={handleChange}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                </select>
              </FormControl>
              <Typography variant="body1" sx={{ marginLeft: 1, color: "#7A7A7A" }}>
                items
              </Typography>
            </Box>

          </Grid>
          <TableContainer
            component={Paper}
            sx={{ overflowX: "auto", boxShadow: "none" }}
          >
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    background: 'var(--table-headbackgroungcolor)',
                    border: '1px solid #ccc'
                  }}
                >
                  {tableHeadData.map((header, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        border: '1px solid #ccc',
                        color: "white",
                        padding: "8px",
                        fontSize: "14px",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Typography variant="subtitle2" sx={{ fontSize: "15px" }}>
                        {header}
                      </Typography>
                    </TableCell>
                  ))}
                  {searchByName && (
                    <TableCell
                      ariant="subtitle2"
                      sx={{ color: "white", padding: "8px", fontSize: "15px" }}
                    >
                      View
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData?.map((row, index) => (

                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#FFFFFF",
                    }}
                  >
                    <TableCell
                      sx={{
                        border: '1px solid #ccc',

                        // borderBottomColor: "#C38F51",
                      }}
                    >
                      <Typography variant="body1">
                        {currentPage * rowsPerPage + index + 1}
                      </Typography>
                    </TableCell>
                    {/* {row[key] === "photo" && (
                      <TableCell
                        sx={{
                          border: '1px solid #ccc',

                          // borderBottomColor: "#C38F51",
                        }}
                      >
                        <Box
                          component="img"
                          src={row.photo}
                          sx={{ height: 50, width: 50 }}
                        />
                      </TableCell>
                    )} */}
                    {/* {Object.keys(row).map(
                      (key) =>
                        key !== "id" && key !== "photo" && key !== "status" && (
                          <TableCell
                            key={key}
                            sx={{
                              color: "#707070",
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              borderBottomColor: "#C38F51",
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{
                                fontSize: "14px",
                                color: "black"

                              }}
                            >

                              {row[key]}
                            </Typography>
                          </TableCell>
                        )
                        
                    )} */}
                    {Object.keys(row).map((key) => {
                      if (key === "id") return null;

                      if (key === "photo") {
                        return (
                          <TableCell
                            key={key}
                            sx={{
                              border: '1px solid #ccc',
                            }}
                          >
                            <Avatar
                              // component="img"
                              src={row?.photo}
                              sx={{ height: 50, width: 50 }}
                            />
                          </TableCell>
                        );
                      }


                      if (key === "status") {
                        return (
                          <TableCell
                            key={key}
                            sx={{
                              border: '1px solid #ccc',

                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              // borderBottomColor: "#C38F51",
                            }}
                          >
                            {row[key] === "approved" ? (
                              <Box
                              // sx={{textAlign:"center"}}
                              >
                                <LuCircleCheckBig style={{ color: "green", fontSize: "35px" }} />
                              </Box>
                            ) : row[key] === "pending" ? (
                              <>
                                {/* <Button
                                  onClick={() => {
                                    handleRejectModalOpen(row.id)

                                  }}
                                  // type="submit"
                                  variant="contained"
                                  sx={{
                                    textTransform: "none",
                                    color: "white",
                                    fontSize: "14px",
                                    padding: { xs: "0px 10px", md: "0px 10px" },
                                    mr: 2,

                                    boxShadow: "none",
                                    minHeight: "20px",
                                    // borderRadius: "23px",
                                    background: "red 0% 0% no-repeat padding-box",
                                    "&:hover": {
                                      backgroundColor: "var(--main-color)",
                                    },
                                  }}
                                >
                                  Reject
                                </Button> */}
                                <Button
                                  onClick={() => {
                                    handleConFrimButton(row.id)
                                  }}
                                  // type="submit"
                                  variant="contained"
                                  sx={{
                                    textTransform: "none",
                                    color: "white",
                                    fontSize: "14px",
                                    padding: { xs: "0px 10px", md: "0px 10px" },

                                    boxShadow: "none",
                                    minHeight: "20px",
                                    // borderRadius: "23px",
                                    background: "var(--main-color) 0% 0% no-repeat padding-box",
                                    "&:hover": {
                                      backgroundColor: "var(--main-color)",
                                    },
                                  }}
                                >
                                  Confirm
                                </Button>
                              </>
                            ) : (<Box
                            // sx={{textAlign:"center"}}
                            >
                              <RxCrossCircled style={{ color: "red", fontSize: "35px" }} />
                            </Box>)}
                          </TableCell>
                        );
                      }

                      // default rendering for other keys
                      return (
                        <TableCell
                          key={key}
                          sx={{
                            border: '1px solid #ccc',

                            color: "#707070",
                            fontSize: "13px",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            // borderBottomColor: "#C38F51",
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: "14px",
                              color: "black",
                            }}
                          >
                            {row[key]}
                          </Typography>
                        </TableCell>
                      );
                    })}


                    {showViewMore && (
                      <TableCell
                        sx={{
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          border: "1px solid #ccc",
                          // borderBottomColor: "#C38F51",
                        }}
                      >
                        <Button variant="none" onClick={() => {
                          handleProfileNavigate(row.id)
                        }
                        }>
                          <Typography variant="body1"
                            color="var(--main-color)"

                          >
                            View More
                          </Typography>
                        </Button>
                      </TableCell>
                    )}
                    {tableActions && (
                      <TableCell
                        sx={{
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          borderBottomColor: "#C38F51",
                          border: '1px solid #ccc',

                        }}
                      >
                        {tableEdit && (
                          // <Button
                          //   onClick={() => {
                          //     handleEditById(row?.id)
                          //   }}
                          //   variant="outlined"
                          //   sx={{

                          //     textTransform: "none",
                          //     borderColor: "#ACB0BF",
                          //     fontSize: "14px",
                          //     padding: { xs: "0px 20px", md: "0px 10px" },

                          //     boxShadow: "none",
                          //     minHeight: "20px",
                          //     color: "var(--main-color)"
                          //     // backgroundColor:"yellow",
                          //     // // background: "var(--main-color) 0% 0% no-repeat padding-box",
                          //     // "&:hover": {
                          //     //   backgroundColor: "var(--main-color)",
                          //     // },
                          //   }}
                          // startIcon={
                          <RiPencilLine
                            onClick={() => {
                              handleEditById(row?.id)
                            }}

                            style={{
                              fontSize: "16px",
                              color: "#ACB0BF",
                              marginRight: "10px",
                              cursor: "pointer",
                            }}
                          />


                        )}
                        {tableView && (
                          <RiEyeLine
                            onClick={() => {
                              handleViewModalOpen()
                              handleViewModal(row?.id)
                            }}

                            style={{
                              fontSize: "16px",
                              marginRight: "10px",
                              color: "#ACB0BF",
                              cursor: "pointer",
                            }}
                          />
                        )}
                        {tableDelete && (
                          <AiOutlineDelete
                            onClick={() => {
                              handleDeletePost(row?.id)
                              // handleDeleteById()
                            }}
                            style={{
                              fontSize: "16px",
                              color: "#ACB0BF",
                              cursor: "pointer",
                            }}
                          />
                        )}
                        {!tableEdit && !tableView && !tableDelete && "--"}

                      </TableCell>
                    )}
                    {/* {isRejectCommandModalOpen && (
                      <RejectCommendModal
                        id={row.id}
                        open={isRejectCommandModalOpen}
                        onClose={handleRejectModalClose}
                      />
                    )} */}
                  </TableRow>

                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <Pagination
              count={pageCount}
              page={currentPage + 1}
              onChange={handlePageChange}
              siblingCount={1}
              boundaryCount={1}
              shape="rounded"
              sx={{
                mt: 2,
                "& .MuiPaginationItem-root": {
                  color: "var(--main-color)", // Default text color
                  border: "1px solid var(--main-color)", // Default border color
                  "&:hover": {
                    backgroundColor: "transparent", // Removes hover background color
                  },
                  "&.Mui-selected": {
                    backgroundColor: "var(--main-color)", // Selected background color
                    color: "white", // Selected text color
                    border: "none", // Remove border for selected items
                    "&:hover": {
                      backgroundColor: "var(--main-color)", // Ensure hover does not change selected color
                    },
                  },
                },
              }}
            />
          </Box>
          {isViewModalOpen &&
            <ModalViewComponent
              open={isViewModalOpen}
              onClose={handleViewModalClose}
            />
          }

        </Grid>
        
      </Grid >
    </>
  );
};

export default CustomTable;
